module.exports = __webpack_public_path__ + "static/media/n13.536fe607.jpg";